import { render, staticRenderFns } from "./MatchTable.vue?vue&type=template&id=a80ca700&scoped=true&"
import script from "./MatchTable.vue?vue&type=script&lang=js&"
export * from "./MatchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ca700",
  null
  
)

export default component.exports